/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Uppercase_Speaker_LabelsInputs */



/**
* | output |
* | --- |
* | "Removes speaker labels in uppercase" |
*
* @param {Remove_Uppercase_Speaker_LabelsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_uppercase_speaker_labels = /** @type {((inputs?: Remove_Uppercase_Speaker_LabelsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Uppercase_Speaker_LabelsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprime les libellés d’intervenant en majuscules")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernt Lautsprecherbezeichnungen in Großbuchstaben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuove le etichette degli altoparlanti in maiuscolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаляет надписи на динамиках, написанные заглавными буквами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elimina las etiquetas de los altavoces en mayúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除大写的扬声器标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大文字のスピーカーラベルを削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर लेबल के बड़े अक्षरों को हटाता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remove as etiquetas dos alto-falantes em maiúsculas.")
	return /** @type {LocalizedString} */ ("Removes speaker labels in uppercase")
});